import React from 'react';
import PropTypes from 'prop-types';
import TextsHeader from './TextsHeader';
import { Content } from './styles';
import BarchartH from './Report/Charts/BarChartH/BarChartH';
import LegendChart from './Report/Charts/SubtitleChart';

function MediaPonderada(props) {
  const data = props.data;
  const examType = props.examType || 'cfp'; // Default para CFP
  const average = data?.average?.acertos_avg * 100;
  const fortmattedAverage = isNaN(Math.round(average)) === true ? 0 : Math.round(average);
  
  // CFA usa 70% como recomendado, CFP usa 80%
  const recommendedPercent = examType === 'cfa' ? 70 : 80;

  return (
    <div style={{ width: '85vw', marginTop: "-370px" }}>
      <TextsHeader>
        <p className="text-media">
          Logo abaixo apresento a Média PONDERADA do seu desempenho em todos os Simulados realizados (média de todas as questões que você fez na plataforma) e seu desempenho por MÓDULO. Esta orientação está baseada na nossa ferramenta própria, a ferramenta PIA
          (peso-importância-absorção).
        </p>
      </TextsHeader>

      <Content style={{marginTop: "200px"}}>
        <p>MÉDIA GERAL DOS SIMULADOS</p>
        <BarchartH
          height='4vw'
          percent={Math.round(average)}
          percentText={`${fortmattedAverage}%`}
          colorbk1={'#F89C3A'}
          displaySubtitle={'none'}
          colorText={'white'}
          total={'100%'}
          zIndex={1}
        />

        <BarchartH
          height='4vw'
          percent={recommendedPercent}
          percentText={`${recommendedPercent}%`}
          colorbk1={'#000A66'}
          displaySubtitle={'none'}
          colorText={'white'}
          total={'100%'}
          zIndex={1}
        />
        <LegendChart
          displaySubtitle={'flex'}
          subtitleMin={"seu desempenho"}
          subtitleRecommended={"recomendado"}
          positionSubtitle={'left'}
        />
      </Content>
    </div>
  );
};

MediaPonderada.propTypes = {
  data: PropTypes.shape({
    average: PropTypes.shape({
      acertos_avg: PropTypes.number
    })
  }).isRequired,
  examType: PropTypes.oneOf(['cfp', 'cfa'])
};

MediaPonderada.defaultProps = {
  examType: 'cfp'
};

export default MediaPonderada;
